export const ROUTER_CONSTANT = {
    HOME: '/home',
    ACCOUNT_LIST: '/account-list',
    ACCOUNT_LIST_ID: '/account-list/:id',
    RESOURCE_LIST: '/resource-list',
    RESOURCE_LIST_ADD: '/resource-list/add',
    RESOURCE_LIST_EDIT: '/resource-list/edit',
    RESOURCE_LIST_DETAIL: '/resource-list/detail',
    RESOURCE_LIST_DELETE: '/resource-list/delete',
  }